<template>
  <app-layout>
    <div class="bg-white shadow-lg p-4 lg:p-6 lg:py-12 lg:px-16 mx-auto lg:max-w-7xl mb-10">

      <h1 class="text-xl">{{ $trans('app.menu.my-results') }}</h1>
      <hr class="w-20 mt-4 mb-8 border-dark-blue">

      <div class="md:grid grid-cols-2 gap-4" v-if="Object.keys(submissions).length > 0">
        <div v-for="result in submissions"
             class="text-center border border-medium-blue rounded-lg p-4 mt-4 md:mt-0">
          <h3 class="text-lg">{{ $trans('app.survey') }} : {{ result.survey.title[$locale()] }}</h3>
          <p class="mt-4 p-2 uppercase rounded-full font-bold text-dark-blue w-1/4 mx-auto" v-if="result.package" :class="result.package.name">
            {{ $trans('app.' + result.package.name) }}</p>
          <p class="text-sm text-gray-600 my-4">{{ $trans('app.test.test-date') }} {{ result.date}}</p>
          <bubble-link class="flex justify-center mt-8" :href="route('submission.results', result.uuid)">
            {{ $trans('app.see-results') }}
          </bubble-link>
        </div>
      </div>

      <div v-else class="text-center">
        Vous n'avez pas encore passé de test.
      </div>

    </div>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import BubbleLink from '@/Components/BubbleLink'

export default {
  components: {AppLayout, BubbleLink},
  props: {
    submissions: Object
  },
}
</script>

<style scoped>

.bronze {
  @apply bg-beige;
}

.silver {
  @apply bg-gray-100;
}

.gold {
  @apply bg-yellow-200;
}

.diamond {
  @apply bg-blue-100;
}

.invitation {
  @apply bg-dark-blue text-white;
}

</style>
